<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal
            v-model="mostrarModal"
            @show="preencherForm()"
            :no-close-on-backdrop="true"
        >
            <div slot="modal-title">
                Parâmetro
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <b-row>
                <b-col sm="12">
                    <div v-if="parametro">
                        <span>Parâmetro:</span><br />
                        <span
                            ><strong>{{ parametro.codParametro }}</strong></span
                        ><br /><br />
                        <span>Descrição:</span><br />
                        <span
                            ><strong>{{ parametro.descricao }}</strong></span
                        ><br /><br />
                        <span>Detalhe:</span><br />
                        <span
                            ><strong>{{ parametro.detalhe }}</strong></span
                        ><br /><br />
                        <span>Atualizado em:</span><br />
                        <span
                            ><strong>{{
                                $moment(parametro.dataAtualizacao).format(
                                    'DD/MM/YYYY HH:mm'
                                )
                            }}</strong></span
                        ><br /><br />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Valor:</label>
                        <b-form-textarea
                            v-model="valor"
                            :rows="4"
                            @input="$v.valor.$touch()"
                            :state="$v.valor.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O valor é obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSalvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ParametrosServicos from './ParametrosServicos'

export default {
    components: {},

    props: {
        parametro: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'ATUALIZAÇÃO',
            valor: ''
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.resetForm()
            this.$emit('atualizar-lista')
            this.mostrarModal = false
        },

        resetForm() {
            this.valor = ''
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.valor = this.parametro.valor
        },

        confirmarSalvar() {
            // this.mostrarModal = false
            this.$swal({
                title: 'Atualização de Parâmetro',
                html: `Confirma a atualização do parâmetro ${this.parametro.codParametro}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                } else {
                    // this.mostrarModal = true
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let parametroDto = {
                parametroId: this.parametro.parametroId,
                valor: this.valor
            }
            ParametrosServicos.atualizarParametro(parametroDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Parâmetro atualizado com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.fecharModal()
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar parâmetro',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {
        valor: {
            required
        }
    }
}
</script>
